
import { Link } from 'react-router-dom';
import { categories } from '../../../mocks/homepage';

export default function CategoriesSection() {
  return (
    <section className="py-24 bg-carbon-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-end justify-between mb-14">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-neon mb-3 block">
              Browse
            </span>
            <h2 className="text-4xl font-bold text-white tracking-tight">Popular Categories</h2>
          </div>
          <Link
            to="/products"
            className="text-sm text-white/40 font-medium hover:text-neon transition-colors flex items-center gap-1.5 cursor-pointer whitespace-nowrap"
          >
            View All <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.name}
              to={`/products?category=${encodeURIComponent(cat.name)}`}
              className="group relative overflow-hidden cursor-pointer border border-white/5 hover:border-neon/30 transition-all"
            >
              <div className="w-full h-56 relative">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="w-8 h-8 bg-neon/10 border border-neon/20 flex items-center justify-center mb-2.5">
                  <i className={`${cat.icon} text-neon text-sm`}></i>
                </div>
                <h3 className="text-sm font-bold text-white mb-0.5">{cat.name}</h3>
                <span className="text-xs text-white/40">{cat.count} products</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
